<template>
  <div class="cardtable">
    <v-card class="mx-auto" light>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col>
              <v-list>
                <v-list-item-title class="text-subtitle-1"
                  >Application(*)</v-list-item-title
                >
                <v-autocomplete
                  :items="applications"
                  item-text="appName"
                  item-value="appName"
                  v-model="application"
                  :rules="[rules.required]"
                >
                </v-autocomplete>
              </v-list>
            </v-col>
            <v-col>
              <v-list>
                <v-list-item-title class="text-subtitle-1"
                  >Channel(*)</v-list-item-title
                >
                <v-autocomplete
                  :items="channels"
                  item-text="text"
                  item-value="code"
                  v-model="channel"
                  :rules="[rules.required]"
                >
                </v-autocomplete>
              </v-list>
            </v-col>
            <v-col>
              <v-list>
                <v-list-item-title class="text-subtitle-1"
                  >Method(*)</v-list-item-title
                >
                <v-autocomplete
                  :items="methods"
                  item-text="text"
                  item-value="code"
                  v-model="method"
                  :rules="[rules.required]"
                >
                </v-autocomplete>
              </v-list>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-list>
                <v-list-item-title class="text-subtitle-1"
                  >Mobile(*)</v-list-item-title
                >
                <p>
                  Mobile, Country code need to be added, e.g. 86 / Multiphone
                  spilt by comma
                </p>
                <v-text-field
                  v-model="mobile"
                  :rules="[rules.required, rules.mobile]"
                />
              </v-list>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-list>
                <v-list-item-title class="text-subtitle-1"
                  >SMS Content(*)</v-list-item-title
                >
                <v-textarea
                  v-model="smscontent"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-list>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="my-2"></v-divider>
      <v-card-actions>
        <v-btn class="successBtn" @click="sendsms()">Submit</v-btn>
      </v-card-actions>
    </v-card>
    <core-loading ref="loading" />
    <core-confirm ref="confirm" @confirm="confirm" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { callPost } from '@/scripts/api'
import CoreLoading from '@/components/core/loading.vue'
import CoreConfirm from '@/components/core/confirm.vue'

export default {
  components: {
    CoreLoading,
    CoreConfirm,
  },
  computed: {
    ...mapState({
      base: (state) => state.base,
    }),
  },
  data: () => ({
    application: null,
    mobile: null,
    channel: null,
    method: null,
    smscontent: null,
    applications: [],
    channels: [
      { code: '00', text: '拜耳中国' },
      { code: '01', text: '拜耳医药' },
      { code: '02', text: '拜耳环境科学' },
      { code: '03', text: '拜耳作物科学' },
    ],
    methods: [
      { code: 'notice', text: '通知' },
      { code: 'verification', text: '验证码' },
      { code: 'marketing', text: '营销' },
    ],
    rules: {
      required: (value) => !!value || 'Required.',
      mobile: (value) => {
        const pattern = /\d{11,15}$/
        const mobiles = value.split(',')
        const invalidmobiles = []
        mobiles.forEach((x) => {
          if (x.trim() !== '') {
            if (!pattern.test(x.trim())) {
              invalidmobiles.push(x)
            }
          }
        })
        return (
          invalidmobiles.length === 0 ||
          'Invalid mobiles: ' + invalidmobiles.join()
        )
      },
    },
  }),
  methods: {
    confirm(arg) {
      if (arg == 'submitted') {
        this.$router.push('send')
      }
    },
    sendsms() {
      if (!this.$refs.form.validate()) return

      var data = {
        application: this.application,
        mobile: this.mobile,
        channel: this.channel,
        method: this.method,
        content: this.smscontent,
      }

      callPost(
        'v1.0/sms/send',
        data,
        this.$refs.loading,
        this.$refs.confirm,
        'Submitting request'
      ).then(() => {
        this.$refs.confirm.show('Request submitted', {
          type: 'alert',
          data: 'submitted',
        })
      })
    },
    getapplication() {
      callPost(
        'v1.0/sms/application',
        {},
        this.$refs.loading,
        this.$refs.confirm,
        'Submitting request'
      ).then((result) => {
        this.applications = result
      })
    },
  },
  created() {
    this.getapplication()
  },
}
</script>

<style>
.cardtable {
  margin-left: 40px;
  margin-right: 40px;
  padding: 10px;
  margin-top: 72px;
}
.successBtn{
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
  color: white !important;
}
</style>
